import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { NotificationService } from '@shared/utils/notification.service';

declare var $: any;

@Component({
  selector: 'sa-header',
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit {

  constructor(private router: Router, private notificationservice: NotificationService) {
  }

  ngOnInit() {
  }


  searchMobileActive = false;

  toggleSearchMobile() {
    this.searchMobileActive = !this.searchMobileActive;

    $('body').toggleClass('search-mobile', this.searchMobileActive);
  }

  onSubmit() {
    // this.router.navigate(['/miscellaneous/search']);
    this.notificationservice.smartMessageBox({
      title: "Thông báo",
      content: "Tính năng đang trong quá trình phát triển. Hãy quay lại sau !",
      buttons: '[Tôi sẽ đợi]'
    }, (ButtonPressed) => {
      
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/layout/header/header.component.ts